import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowUpRight } from "lucide-react";

export default function ExperienceTeaser() {
    return (
        <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24" data-testid="experience-teaser">
            <div className="relative overflow-hidden rounded-[32px] bg-[#0B1440] text-white px-6 sm:px-12 py-16 lg:py-24">
                <div className="absolute -top-40 -right-32 w-[500px] h-[500px] rounded-full bg-[#1BB6F0]/25 blur-3xl pointer-events-none" />
                <div className="absolute -bottom-32 -left-24 w-[400px] h-[400px] rounded-full bg-[#1E90FF]/20 blur-3xl pointer-events-none" />
                <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
                    <div className="lg:col-span-7">
                        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/15 rounded-full px-3 py-1.5 text-xs tracking-widest uppercase font-semibold text-[#1BB6F0]">
                            <Sparkles className="w-3.5 h-3.5" /> Experience Smart Living
                        </div>
                        <h2 className="mt-6 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight">
                            Don't just read about smart homes.<br />
                            <span className="text-[#1BB6F0]">Experience one.</span>
                        </h2>
                        <p className="mt-5 text-white/70 max-w-xl leading-relaxed">
                            Step inside a real interactive home. Toggle lights, change AC temperature, open curtains, and
                            run automation scenes like "Movie Night" or "Good Night" — with Alexa, Google Home or Siri.
                        </p>
                        <div className="mt-8 flex flex-wrap gap-3">
                            <Link
                                to="/experience-smart-living"
                                data-testid="teaser-enter-cta"
                                className="inline-flex items-center gap-1.5 bg-[#1BB6F0] hover:bg-[#1E90FF] text-white rounded-full px-7 py-3.5 font-medium transition-colors"
                            >
                                Enter the Smart Home <ArrowUpRight className="w-4 h-4" />
                            </Link>
                            <Link
                                to="/calculator"
                                data-testid="teaser-calc-cta"
                                className="inline-flex items-center gap-1.5 bg-white/10 hover:bg-white/15 border border-white/20 text-white rounded-full px-7 py-3.5 font-medium transition-colors"
                            >
                                Calculate your cost
                            </Link>
                        </div>
                    </div>
                    <div className="lg:col-span-5">
                        <div className="grid grid-cols-2 gap-3">
                            {[
                                { t: "Living Room", s: "4/6 devices active", c: "#1BB6F0" },
                                { t: "Bedroom", s: "AC · 22°C", c: "#1E90FF" },
                                { t: "Entrance", s: "Locked · Camera ON", c: "#1BB6F0" },
                                { t: "Scene", s: "Good Night ready", c: "#1E90FF" },
                            ].map((k, i) => (
                                <div key={i} className="bg-white/[0.04] border border-white/10 rounded-2xl p-5 backdrop-blur-sm">
                                    <div className="text-[10px] tracking-widest uppercase text-white/50 font-semibold">{k.t}</div>
                                    <div className="mt-2 font-semibold flex items-center gap-2">
                                        <span className="w-1.5 h-1.5 rounded-full animate-soft-pulse" style={{ background: k.c }} />
                                        {k.s}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
